import { gql } from '@apollo/client'
import { MUTATION_STATE, VOOH_CREATION_FIELDS } from '../../fragments'

const PAYLOAD_TYPE = 'CreateVoohCampaignCreationsPayload'

export const CREATE_VOOH_CREATIONS = gql`
  ${VOOH_CREATION_FIELDS}
  ${MUTATION_STATE('CreateVoohCampaignCreationsPayload')}
  mutation createVoohCampaignCreations($voohCampaignId: ID!, $details: String!, $mediaFormat: VoohMediaFormatEnum!, $files: [Upload!]!, $duration: Int!, $hourFrequency: Int) {
    createVoohCampaignCreations(input: 
    { voohCampaignId: $voohCampaignId, details: $details, mediaFormat: $mediaFormat, files: $files, duration: $duration, hourFrequency: $hourFrequency }) {
      voohCreations {
        ...VoohCreationFields
      }
      voohCampaign {
        publishable
      }
      ...MutationState${PAYLOAD_TYPE}Fields
    }
  }
`
